import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { VerificationStatus } from '@project/detail/connections/shared/verification-status.enum';

@Component({
  selector: 'oes-verification-status',
  templateUrl: './verification-status.component.html',
  styleUrls: ['./verification-status.component.scss'],
})
export class VerificationStatusComponent implements INoRowsOverlayAngularComp {
  public status: VerificationStatus;
  public verificationStatus = VerificationStatus;
  public reason = {};
  public isFilter = false;
  private params: any;
  private readonly hiddenDiagnosisStatuses = new Set<string>([
    VerificationStatus.NOT_VERIFIED,
    VerificationStatus.VERIFIED,
    VerificationStatus.VERIFICATION_IN_PROGRESS,
    VerificationStatus.VERIFICATION_NOT_RUN
  ]);
  private readonly redStatusText = new Set<string>([
    VerificationStatus.VERIFICATION_ERROR,
    VerificationStatus.NOT_VERIFIED,
    VerificationStatus.DID_NOT_MEET_REQUIREMENTS
  ]);

  constructor(private _translateService: TranslateService) {
    this.reason = this._translateService.instant(
      'project-connections.verification-status'
    );
  }

  agInit(params): void {
    if (params) {
      this.params = params;
      if (params.rowIndex === undefined) {
        // call from grid
        this.isFilter = true;
      } else {
        this.isFilter = false;
      }
      this.status = params.value;
    }
  }

  get showDiagnosisAction(): boolean {
    return !this.isFilter &&
      !!this.params?.data?.id &&
      !!this.status &&
      !this.hiddenDiagnosisStatuses.has(this.status) &&
      this.params?.data?.diagnosisAvailable === true;
  }

  get statusClass(): string {
    if (this.status === VerificationStatus.VERIFIED) {
      return 'status-label--verified';
    }

    if (this.redStatusText.has(this.status)) {
      return 'status-label--error';
    }

    return '';
  }

  openDiagnosis(event: MouseEvent): void {
    event.stopPropagation();
    this.params?.context?.componentParent?.openConnectionDiagnosis(this.params.data);
  }
}
